import { PROBABILITIES } from '../enums/porbabilities';

export const BetTypeTypeIndexes = {
  RANGE: 2,
};

export const getOdd = (partnerMargin = 4, markets, precision = 2) => {
  let odd = 0;
  let marketProbabilities = 0;
  if (markets.length) {
    for (const market of markets) {
      const currentMarket = PROBABILITIES.filter((x) => x.sum >= market.from && x.sum <= market.to);
      const probabilities = currentMarket.reduce((acc, current) => acc + current.probabilities, 0);
      marketProbabilities += probabilities;
    }
    odd = 1 / marketProbabilities;
    odd = calculateOdd(odd, partnerMargin);
    odd = Math.trunc(odd * Math.pow(10, precision)) / Math.pow(10, precision);
    return odd;
  }
  return odd;
};

const calculateOdd = (odd, margin) => {
  return odd * (1 - margin / 100);
};

export const countNumber = (betType, ranges) => {
  let countOfNumbers = 0;
  if (+betType === +BetTypeTypeIndexes.RANGE) {
    for (const range of ranges) {
      countOfNumbers += range?.to - range?.from + 1;
    }
  }
  return countOfNumbers;
};

export const countMaxNumberByMargin = (margin = 4) => {
  return Math.floor((99 - margin) / 1.01);
};
